<i [class]="iconClass" (click)="onClick($event)" [title]="tooltip"></i>
